export default __webpack_public_path__ + "static/media/ddsu5168_4p_rs485_gw214.51881c94.png";